import React from "react";
import { BiLoaderAlt } from "react-icons/bi";
function Loader({ size = 30 }) {
  return (
    <div className="mx-4 flex animate-spin items-center justify-center text-primary">
      <BiLoaderAlt size={size} />
    </div>
  );
}

export default Loader;
